module.exports = __webpack_public_path__ + "img/modal-successfully-sent.8598a3ef.svg";